import { useNavigate } from "react-router-dom";
import avatarImage from "../Images/ProfessionalGirl.jpg";
import "./Error500.scss";
import Cookies from "js-cookie";

const Error500 = () => {
  const navigate = useNavigate();

  const handleRetry = () => {
    window.location.reload();
  };

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();

    Cookies.remove("Refresh_Token");

    navigate("/");
    window.location.reload();
  };

  return (
    <div className="error-page">
      <div className="error-content">
        <img
          src={avatarImage}
          alt="Access Denied Avatar"
          className="bouncing-avatar"
        />
        <h1>Oops! Something went wrong. Please login again.</h1>
        <div className="error-actions">
          <button onClick={handleRetry} className="retry-button">
            Retry
          </button>
          <button onClick={handleLogout} className="home-button">
            logout
          </button>
        </div>
      </div>
    </div>
  );
};

export default Error500;
